import React from "react";

import { Button } from "@formant/ui-kit";

import { useStores } from "../../context/StoreContext";
import { Ducalis } from "../Ducalis";

export interface IFleetHeaderProps {
    handleSideBarClose: () => void;
}
export const FleetHeader = (props: IFleetHeaderProps) => {
    const { routerStore } = useStores();

    const hideDucalis = false;

    const handleLogoClick = async () => {
        props.handleSideBarClose();
        await routerStore.navigate(routerStore.routeTo.home());
    };

    return (
        <div className="flex items-center justify-between px-4 py-2">
            <div className="flex items-center space-x-2">
                <div className="flex items-center">
                    <Button
                        className="[&_svg]:size-8 w-[3.75rem] h-[3.75rem] max-h-[3.75rem] rounded-full py-2  hover:bg-formant-color-background-active"
                        variant="ghost"
                        data-testid="logo-button"
                        onClick={handleLogoClick}
                    >
                        <div>
                            <svg
                                width="32px"
                                height="32px"
                                viewBox="0 0 32 32"
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <polygon
                                    fill="var(--color-text-primary)"
                                    points="0,31.2 8.9,10 17.9,31.2 "
                                />
                                <path
                                    fill="var(--color-text-primary)"
                                    d="M16.4,15.9c0-2.4,2-4.4,4.4-4.4c2.4,0,4.4,2,4.4,4.4c0,2.4-2,4.4-4.4,4.4
        C18.4,20.3,16.4,18.3,16.4,15.9"
                                />
                                <polygon
                                    fill="var(--color-text-primary)"
                                    points="8.9,7.8 31.3,7.8 31.3,0.9 8.9,0.9 "
                                />
                            </svg>
                        </div>
                    </Button>
                </div>
            </div>

            <div className="flex items-center space-x-6">
                <div className="flex items-center space-x-2">
                    {!hideDucalis && <Ducalis />}
                </div>
            </div>
        </div>
    );
};
